import { createSlice } from '@reduxjs/toolkit';

export enum EOptions {
  SELECT = 'select',
  SEARCH = 'search',
  FILTER = 'filter',
}

export type TCardFiltersSliceType = {
  filters: { [key: string]: boolean };
  search: string;
  option: EOptions | null;
};

const initialState = {
  search: '',
  filters: {},
  option: null,
} as TCardFiltersSliceType;

const cardFilters = createSlice({
  name: 'cardsFilters',
  initialState,
  reducers: {
    setSearch(state, { payload }) {
      state.search = payload;
    },
    setFilter(state, { payload: { _id, name } }) {
      state.filters = {
        ...state.filters,
        [_id]: state.filters[_id] ? false : name,
      };
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    deleteFilter(state, { payload }) {
      state.filters[payload] = false;
    },
    setOption(state, { payload }) {
      state.option = payload;
    },
    reset() {
      return initialState;
    },
  },
});

export const {
  actions: {
    setSearch: setCardsSearch,
    setFilter: setCardsFilter,
    clearFilters: clearCardsFilters,
    deleteFilter: deleteCardsFilter,
    setOption: setCardsFilterOption,
    reset: resetCardsFilters,
  },
  name: cardFiltersName,
} = cardFilters;
export default {
  [cardFilters.name]: cardFilters.reducer,
};
